import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings';

import {
  WEB_PLATFORM_ENVIRONMENT,
  WEB_PLATFORM_IS_BUILD_MODE,
  WEB_PLATFORM_VERSION,
} from 'shared/infra/constants/platform.const';

import type { ReactNode } from 'react';
import type { PartnerId } from 'shared/domain';

export function StatsigInitialization({ children }: { children: ReactNode }) {
  const countryCode = useSelector<any, string>(
    s => s.appReducer?.countryCode ?? '',
  ).toUpperCase();
  const partnerId = useSelector<any, PartnerId>(
    s => s.partnerReducer.profile.id ?? NaN,
  );
  const stores = useSelector<any, any[]>(s => s.partnerReducer.profile.stores);

  const CONFIG_BASE = {
    appVersion: WEB_PLATFORM_VERSION,
    custom: {
      environment: WEB_PLATFORM_ENVIRONMENT,
      buildMode: WEB_PLATFORM_IS_BUILD_MODE,
    },
  };

  const { client } = useClientAsyncInit(
    process.env.REACT_APP_STATSIG_SDK_CLIENT_KEY as string,
    CONFIG_BASE,
  );

  useEffect(() => {
    if (!!countryCode && !!partnerId && !!client) {
      const customID = `${countryCode}-${partnerId}`;
      client
        .updateUserAsync({
          ...CONFIG_BASE,
          custom: {
            ...CONFIG_BASE.custom,
            partnerId,
            numberOfStores: stores.length,
            storeIds: stores.map(s => `${countryCode}-${s.id}-s`),
          },
          userID: customID,
          country: countryCode,
          customIDs: {
            'Country-Partner': customID,
          },
        })
        .then();
    }
  }, [countryCode, partnerId, stores, client]);

  return (
    <StatsigProvider
      client={client}
      loadingComponent={children}
      options={{
        environment: {
          tier: CONFIG_BASE.custom.environment,
          buildMode: CONFIG_BASE.custom.buildMode.toString(),
        },
      }}
    >
      {children}
    </StatsigProvider>
  );
}
